export {
  EnumLang,
  EnumGoodsType,
  EnumGoodsStatus,
  EnumPartitionID,
  EnumCouponType,
  EnumGoodsDetailIsSpike,
  EnumOrderDetailPayStatus,
  EnumRouteType,
} from '@didi/trade-sdk/lib/quartz.js'

/**
 * 端内系统状态栏文字、导航栏按钮颜色
 * @readonly
 * @enum {EnumNavStyle}
 */
export const EnumNavStyle = {
  /** 白色 1 */
  White: 1,
  /** 黑色 0 */
  Black: 0,
}

/**
 * 售罄类型
 * @readonly
 * @enum {string}
 */
export const EnumSoldOutType = {
  /** 本轮售罄 */
  Turn: 'turn',
  /** 活动售罄 */
  Activity: 'activity',
}
// 上线位置
export const EnumShowChannelType = {
  Live: 20, // 直播
  NoLive: 21, // 非直播
}
/**
 * 活动类型
 * @readonly
 * @enum {string}
 */
export const EnumLimitType = {
  /** 不限制 */
  None: 'none',
  /** 限时 */
  Time: 'time',
  /** 限量 */
  Count: 'count',
}

/**
 * 订单详情接口请求类型，目前用于前端区分传给函数的 id 是 order id，还是 coupon id
 * @readonly
 * @enum {number}
 */
export const EnumOrderDetailType = {
  Order: 1,
  Coupon: 2,
}

/**
 * 买一赠一活动角色
 * @readonly
 * @enum {number}
 */
export const EnumBogoRole = {
  Buyer: 0,
  Receiver: 1,
}

/**
 * 套餐划线价类型枚举
 * @readonly
 * @enum {number}
 */
export const EnumDiffPriceMarkType = {
  NewCustomer: 1,
}

/**
 * 更新订单状态枚举
 * @readonly
 * @enum {number}
 */
export const EnumOrderOperateType = {
  /** 删除订单 1 */
  Delete: 1,
  /** 关单 2 */
  Close: 2,
  /** 支付待支付订单 3 */
  Pay: 3,
}

/**
 * 商城页面状态枚举
 * @readonly
 * @enum {number}
 */
export const EnumMallPageStatus = {
  /** 省钱套餐 */
  SaveMoneySet: 1,
  /** 省钱卡 */
  SaveMoneyCard: 2,
}

/**
 * 商城页面状态枚举
 * @readonly
 * @enum {number}
 */
export const EnumCardType = {
  /** 未开通 */
  NotOpen: 1,
  /** 已开通且在有效期内 */
  OpeningAndVaild: 2,
  /** 已过期 */
  Overdue: 3,
  /** 即将过期 */
  ExpiringSoon: 4,
  /** 已退款 */
  Refunded: 5,
  /** 待生效 */
  PenddingValid: 7,
  /** 助力失败-退款中 */
  AssistFailRefunding: 8,
  /** 助力失败-已退款 */
  AssistFailRefunded: 9,
  /** 自动续费 */
  AutomaticRenewal: 10,
}

/**
 * 订单关闭类型
 */
export const EnumOrderCloseType = {
  Timeout: 5,
  Cancel: 8,
}

export const EnumUIActivitiesInProgressType = {
  InProgress: 1,
  Recommends: 2,
}

export const EnumProductType = {
  /**
   * 默认
   */
  Default: 0,
  /**
   * 租车业务线
   */
  CarRental: 271,
  /**
   * 洗车卡
   */
  WashingCard: 492,
  /**
   * 顺风车
   */
  Beatles: 259,
  /**
   * 豪华车
   */
  Luxed: 276,
}

export const EnumProductID = {
  Rights: 115, // 权益
}
